import React from "react";
import { Link } from "react-router-dom";
import LegalPage from "./LegalPage";
import { EMAIL, PHONE_DISPLAY } from "../data";

const H = ({ children }) => <h2 className="font-heading font-normal text-xl text-[#172B38] mt-8 mb-2">{children}</h2>;
const P = ({ children }) => <p>{children}</p>;
const UL = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1">
    {items.map((it) => <li key={it}>{it}</li>)}
  </ul>
);

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" updated="21 July, 2026" updatedLabel="Effective Date">
      <P>
        By using the Honest Water LLC website, requesting services, or opting in to receive SMS communications, you
        agree to these Terms &amp; Conditions. Please read them carefully.
      </P>

      <H>Description of SMS Use Cases</H>
      <P>
        Users who voluntarily opt in to receive SMS messages from Honest Water LLC may receive text messages related
        to:
      </P>
      <UL items={[
        "Appointment confirmations",
        "Appointment reminders",
        "Service scheduling updates",
        "Technician arrival notifications",
        "Customer support communications",
        "Estimate and quote follow-ups",
        "Responses to customer inquiries",
        "Other important service-related notifications",
      ]} />
      <P>
        SMS messages are used only for communications related to services requested by the customer. SMS consent is
        voluntary and is not required as a condition of purchasing products or services.
      </P>

      <H>Opt-Out Instructions</H>
      <P>
        You may stop receiving SMS messages at any time by replying STOP to any text message. After opting out, you
        will receive a confirmation message and will no longer receive SMS messages unless you opt in again.
      </P>
      <P>You may also reply HELP for assistance.</P>

      <H>Customer Support Contact</H>
      <P>
        Customers who need assistance regarding appointments, SMS communications, or services should contact Honest
        Water LLC using the contact information available on the website. Customer support is available for:
      </P>
      <UL items={[
        "Appointment questions",
        "SMS enrollment",
        "SMS opt-out requests",
        "General customer service",
        "Service inquiries",
      ]} />

      <H>Message &amp; Data Rate Disclosure</H>
      <UL items={[
        "Message frequency varies depending on customer interactions.",
        "Standard message and data rates may apply.",
        "Charges are determined by the customer's mobile carrier.",
      ]} />

      <H>Carrier Liability Disclaimer</H>
      <P>
        Wireless carriers are not responsible for delayed, failed, or undelivered SMS messages. Honest Water LLC cannot
        guarantee message delivery because delivery depends on the customer's wireless provider and network
        availability.
      </P>

      <H>Age Restriction (18+)</H>
      <P>
        SMS communications and website services are intended for individuals who are at least 18 years of age. By
        opting into SMS communications, you represent that you are 18 years of age or older, or that you have
        permission from a parent or legal guardian where permitted by law.
      </P>

      <H>Link to Privacy Policy</H>
      <P>
        Please review our <Link to="/privacy" className="text-[#172B38] underline">Privacy Policy</Link> to understand:
      </P>
      <UL items={[
        "What information is collected",
        "How information is used",
        "Cookie practices",
        "Data security",
        "User rights",
        "Honest Water LLC's commitment not to sell, rent, trade, or share personal information or mobile information for marketing or promotional purposes",
      ]} />

      <H>Changes to These Terms</H>
      <P>
        Honest Water LLC may update these Terms &amp; Conditions periodically. Any revisions become effective
        immediately upon publication on the website. We encourage you to review this page from time to time.
      </P>

      <H>Contact Us</H>
      <P>
        For questions regarding these Terms &amp; Conditions or our SMS communications, please contact Honest Water LLC
        using the contact information displayed elsewhere on the website:
      </P>
      <P>Email: <a href={`mailto:${EMAIL}`} className="text-[#172B38] underline">{EMAIL}</a></P>
      <P>Phone: {PHONE_DISPLAY}</P>
    </LegalPage>
  );
}
